import type { LogAccelBuild, LogAccelInterval } from './shape';

export const LOG_ACCEL_INTERVALS: LogAccelInterval[] = [
  { a: -0.5, b: 0.4615 },
  { a: -0.6, b: 0.5455 },
  { a: -0.7, b: 0.6269 },
  { a: -0.8, b: 0.7059 },
  { a: -0.9, b: 0.7827 },
  { a: -1.0, b: 0.8573 },
  { a: -1.1, b: 0.9298 },
  { a: -1.2, b: 1.0003 },
  { a: -1.3, b: 1.0689 },
  { a: -1.4, b: 1.1356 },
  { a: -1.5, b: 1.2006 },
  { a: -1.6, b: 1.2639 },
  { a: -1.7, b: 1.3256 },
  { a: -1.8, b: 1.3857 },
  { a: -1.9, b: 1.4444 },
  { a: -2.0, b: 1.5016 },
  { a: -2.1, b: 1.5574 },
  { a: -2.2, b: 1.6119 },
  { a: -2.3, b: 1.6651 },
  { a: -2.4, b: 1.7171 },
  { a: -2.5, b: 1.7679 },
  { a: -2.6, b: 1.8176 },
  { a: -2.7, b: 1.8662 },
  { a: -2.8, b: 1.9137 },
  { a: -2.9, b: 1.9601 },
  { a: -3.0, b: 2.0055 },
];

export const LOG_ACCEL_BUILDS: LogAccelBuild[] = LOG_ACCEL_INTERVALS.map((interval, index) => ({
  id: `log-accel-${String(index + 1).padStart(2, '0')}`,
  interval,
}));
